module.exports = __webpack_public_path__ + "img/card_ip_stipulation44.43118a95.svg";